import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faStar } from "@fortawesome/free-regular-svg-icons"

export const StarRegular = (props) => {
  return <FontAwesomeIcon faIcon={faStar} {...props} />
}
